import {
  ConsolidatedContact,
  ContactDetails,
} from '../../../../../api/CoachingNotes/schema';
import { ContactReviewItemLabel } from '@amzn/aet-contactrecommendation-kit';
import { ContactFromGetter } from '../../Data';
import { ContactInput } from '../../../../../api/CoachingForm/schema';

const parseContactDetailsToContactInput = (
  contactDetail: ContactDetails | undefined
): ContactInput | undefined => {
  if (contactDetail === undefined) return undefined;
  const contactInput = {
    cscContactID: contactDetail.cscContactID,
    followedSecurityPolicies: contactDetail.followedSecurityPolicies,
    content: contactDetail.content ?? '',
    vertical: contactDetail.vertical,
    contactTime: contactDetail.contactTime,
    marketplaceID: contactDetail.marketplaceID,
    marketplaceDomainName: contactDetail.marketplaceDomainName,
    relatedMetric: contactDetail.relatedMetric,
  };

  return contactInput;
};

export const parseConsolidatedContactToContactGetter = (
  contactList: ConsolidatedContact[]
): ContactFromGetter[] => {
  const getterList: ContactFromGetter[] = [];

  contactList.forEach(contact => {
    const formatted: ContactFromGetter = {
      contactID: contact.contactID,
      userID: contact.userID,
      time: contact.contactDate,
      marketplaceID: contact.marketplaceID,
      marketplaceDomainName: contact.marketplaceDomainName,
      contactInfo: parseContactDetailsToContactInput(contact.contactInfo),
      status: contact.status,
      calWeek: contact.calWeek.toString(),
      calYear: contact.calYear.toString(),
      label: ContactReviewItemLabel[ContactReviewItemLabel.REVIEWED],
    };
    getterList.push(formatted);
  });

  return getterList;
};

export const getContactInput = (
  selectedContacts: String[],
  contactList: ConsolidatedContact[]
) => {
  const list: ContactInput[] = [];
  selectedContacts.forEach(contact => {
    const selectedContactID = contact;
    const selectedContact = contactList.find(
      ({ contactID }) => selectedContactID === contactID
    );
    if (selectedContact && selectedContact.contactInfo) {
      const { calWeek, calYear } = selectedContact;
      if (calWeek && calYear) {
        const {
          content,
          cscContactID,
          followedSecurityPolicies,
          vertical,
          marketplaceID,
          relatedMetric,
        } = selectedContact.contactInfo;

        const contactInput: ContactInput = {
          content: content || '',
          cscContactID,
          followedSecurityPolicies,
          vertical,
          contactTime: {
            calWeek: calWeek,
            calYear: calYear,
          },
          marketplaceID,
          relatedMetric,
        };
        list.push(contactInput);
      }
    }
  });
  return list;
};
